import React from 'react';
import { toAbsoluteUrl } from '@/utils';
import { Link } from "react-router-dom";

interface NoCompaniesContentProps {
    onAddNewJob?: () => void;
}

const NoCompaniesContent: React.FC<NoCompaniesContentProps> = ({}) => {
    return (
        <div className="grid lg:grid-cols-3 gap-5 lg:gap-7.5">
            <div className="lg:col-span-3">
                <div className="mb-7.5">
                    <div className="card">
                        <div className="card-body px-10 py-7.5 lg:pr-12.5 flex flex-col justify-start">
                            <div className="flex flex-wrap md:flex-nowrap items-start gap-6 md:gap-10">
                                <div className="flex flex-col gap-3">
                                    <h1 className="text-2xl font-semibold text-gray-900">
                                        You need to create a company first!
                                    </h1>
                                    <h2 className="text-1xl font-semibold text-gray-900">
                                        Set up your company to unlock the power of smart hiring.
                                    </h2>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        Before adding jobs, it's essential to establish your company profile.
                                        Creating a company will serve as the foundation for managing jobs,
                                        candidates, and making the most of our smart hiring tools.
                                    </p>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        Setting up your company is quick and straightforward.
                                        Once your company is created, you'll be able to add job listings,
                                        sort through candidates, and match the right talent to the right roles.
                                    </p>

                                    <p className="text-sm text-gray-700 leading-5.5">
                                        Don't worry – UPFLINX Buddy guides you through the process step by
                                        step, making it simple and intuitive, even if you’re new to AI-driven tools.
                                    </p>
                                </div>
                                <img
                                    src={toAbsoluteUrl('/media/images/avatar-high.png')}
                                    className="dark:hidden max-h-[250px]"
                                    alt="Setup Company Illustration"
                                />
                            </div>
                        </div>
                        <div className="card-footer justify-center">
                            <Link to="/companies" className="btn btn-link" role="button">
                                Create your first company now!
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { NoCompaniesContent };
